var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Creates a throttled function that only invokes func at most once per every wait milliseconds.
 *
 * @template T
 * @template A
 * @param {(...args: A[]) => T} fn
 * @param {number} [ms=0]
 * @return {*}  {{ (...args: A[]): Promise<T>; cancel(): void; }}
 */
export var throttle = function (fn, ms) {
    if (ms === void 0) { ms = 0; }
    var wait = false;
    var timer = null;
    var throttled = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!wait) {
            wait = true;
            fn.apply(void 0, __spread(args));
            timer = window.setTimeout(function () {
                wait = false;
            }, ms);
        }
    };
    throttled.cancel = function () {
        clearTimeout(timer);
        wait = false;
    };
    return throttled;
};
//# sourceMappingURL=throttle.js.map